module.exports = __webpack_public_path__ + "static/img/fj1.a861a09a.png";